export default Object.freeze({
    FAILED: 0,
    SUCCESSFUL: 1,
    PENDING: 2,
  })